export default __webpack_public_path__ + "static/capacitacion-868d20b309039ed315f62b47e60afce9.svg";